export default __webpack_public_path__ + "static/media/1693.0f5820a1.png";